import { TASKS } from '../insertTask/insertTaskActionTypes';

export const SHOW_FILTER_PANEL = 'SHOW_FILTER_PANEL';
export const HIDE_FILTER_PANEL = 'HIDE_FILTER_PANEL';

export const SHOW_FILTER_PANEL_TASKS = `${SHOW_FILTER_PANEL}_${TASKS}`;

export const HIDE_FILTER_PANEL_TASKS = `${HIDE_FILTER_PANEL}_${TASKS}`;

export const GET_ASSIGNEES = 'GET_ASSIGNEES';
export const GET_ASSIGNEES_REQUEST = `${GET_ASSIGNEES}_REQUEST`;
export const GET_ASSIGNEES_SUCCESS = `${GET_ASSIGNEES}_SUCCESS`;
export const GET_ASSIGNEES_FAILURE = `${GET_ASSIGNEES}_FAILURE`;

export const GET_ASSIGNEES_INFINITE = 'GET_ASSIGNEES_INFINITE';
export const GET_ASSIGNEES_INFINITE_REQUEST = `${GET_ASSIGNEES_INFINITE}_REQUEST`;
export const GET_ASSIGNEES_INFINITE_SUCCESS = `${GET_ASSIGNEES_INFINITE}_SUCCESS`;
export const GET_ASSIGNEES_INFINITE_FAILURE = `${GET_ASSIGNEES_INFINITE}_FAILURE`;
